export default "__VITE_ASSET__a5e97efc__"